<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="10" cy="10" r="8" fill="currentColor"/>
<circle cx="10" cy="6" r="1" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M8 8H11V14H12V15H9V9H8V8Z" fill="white"/>
</svg>
